import { ComponentsOverrides, Theme } from "@mui/material";
import { InternalThemeConfig } from "../../config";

const paper = ({ spacing, palette }: InternalThemeConfig): ComponentsOverrides<Theme>["MuiPaper"] => ({
	root: {
		padding: spacing(3),
		marginBottom: spacing(1),
		color: palette.black,
	},
});

export default paper;
